import { render, staticRenderFns } from "./AdminFile.vue?vue&type=template&id=756c22a6&scoped=true&"
import script from "./AdminFile.vue?vue&type=script&lang=js&"
export * from "./AdminFile.vue?vue&type=script&lang=js&"
import style0 from "./AdminFile.vue?vue&type=style&index=0&id=756c22a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756c22a6",
  null
  
)

export default component.exports